export default "__VITE_ASSET__pMXB0Btx__"